import React from "react";

function Twitter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 18 18" fill="currentColor" {...props}>
      <path
        d="M16.6572 5.24588C16.6682 5.40862 16.6682 5.57136 16.6682 5.7356C16.6682 10.74 12.9534 16.5115 6.1607 16.5115V16.5085C4.15411 16.5115 2.18921 15.9221 0.5 14.8107C0.791773 14.8467 1.08501 14.8647 1.37898 14.8654C3.04186 14.8669 4.65722 14.2947 5.96545 13.241C4.38519 13.2103 2.99945 12.1536 2.51536 10.611C3.06892 10.7205 3.63931 10.698 4.18263 10.5457C2.45978 10.1888 1.22029 8.63638 1.22029 6.83351C1.22029 6.81702 1.22029 6.80127 1.22029 6.78552C1.73364 7.07875 2.30841 7.24148 2.89634 7.25948C1.27367 6.14732 0.773492 3.93348 1.75338 2.20261C3.62834 4.56869 6.3947 6.00708 9.36435 6.15932C9.06673 4.84391 9.47331 3.46552 10.4327 2.54084C11.9201 1.10695 14.2594 1.18044 15.6576 2.70508C16.4846 2.53784 17.2773 2.22661 18.0027 1.78564C17.7271 2.66233 17.1501 3.40702 16.3793 3.88024C17.1113 3.79174 17.8265 3.59076 18.5 3.28403C18.0042 4.04597 17.3797 4.70967 16.6572 5.24588Z"
        fill="#1D9BF0"
      />
    </svg>
  );
}

const MemoTwitter = React.memo(Twitter);
export default MemoTwitter;
